import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Pmsversion } from 'lumen/models';

export default class Pms extends Model {
  [Type] = 'pms' as const;

  @hasMany('pms-version', { async: false, inverse: null })
  declare versions: HasMany<Pmsversion>;

  @attr('string') declare displayName: string;
  @attr('string') declare versionDeterminationHelpArticle: string;
}
